module.exports = __webpack_public_path__ + "img/fondo_newepisodios.6db21c46.svg";